import React from 'react';
import PropTypes from 'prop-types';

import { LOGO_ROOT, LARGE_LOGO_ROOT } from '../../constants';

import { getMerchantCardUrl } from '../../services/partner/utils';

import LocalizedNavLink from '../router/LocalizedNavLink';

import './LogoPartnerComponent.scss';

class LogoPartenaireComponent extends React.Component {
    render() {
        const { partenaire, small, title, titleTag, cssClass, url } = this.props;

        const urlFicheMarchand = getMerchantCardUrl(partenaire);
        const rootSrc = small ? LOGO_ROOT : LARGE_LOGO_ROOT;
        const fileName = partenaire.logo || `logo-${partenaire.ebcId}.gif`;

        const logo = (
            <img
                src={`${rootSrc}/${fileName}`}
                alt={partenaire.name}
                width={small ? '90' : '189'}
                height={small ? '50' : '91'}
                className={cssClass}
            />
        );

        if (titleTag) {
            return <h3 className="title-logo">{logo}</h3>;
        } else if (!url) {
            return <div>{logo}</div>;
        } else {
            return (
                <LocalizedNavLink
                    to={url ? url : partenaire && urlFicheMarchand ? urlFicheMarchand : ''}
                    title={title ? title : ''}
                    className={cssClass ? cssClass : ''}>
                    {logo}
                </LocalizedNavLink>
            );
        }
    }
}

LogoPartenaireComponent.propTypes = {
    partenaire: PropTypes.object.isRequired,
    url: PropTypes.string,
    title: PropTypes.string,
    titleTag: PropTypes.bool,
    small: PropTypes.bool,
    cssClass: PropTypes.string
};

export default LogoPartenaireComponent;



// WEBPACK FOOTER //
// ./src/components/partner/LogoPartenaireComponent.js